module.exports = __webpack_public_path__ + "de0e77240ccd471bc2498dfaab3d49ac.jpg";